import React from 'react';
import { ContentArea } from '@styles/common';
import { TourneyTable } from '@screens/tourneys/tourneys.styles';
import { useAuth } from '@domain/auth/auth.hook';
import { useFormData } from '@domain/hooks/use.form.data';
import { AxiosResponse, CancelToken } from 'axios';
import { useParams } from 'react-router-dom';
import { Loading } from '@components/loading';
import { ErrorDisplay } from '@components/error/error.display';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { GameType } from '@domain/game.selection/types/game.type';
import TourneyInfosPraia from '@screens/tourneys/tourney.infos.praia';
import TourneyInfosRex from '@screens/tourneys/tourney.infos.rex';
import { Tourney } from './tourney.data.props';

const columns = [
  { field: 'pid', headerName: 'Pid', width: 200, flex: 0.5 },
  { field: 'name', headerName: 'Name', width: 200, flex: 0.5 },
  { field: 'points', headerName: 'Points', width: 200, flex: 0.5 },
];

interface EndPoint {
  tourney: Tourney;
  tourneyPoints: TourneyPoint[];
}
interface TourneyPoint {
  pid: number;
  name: string;
  points: number;
}
function createData(tourneyPoints: TourneyPoint) {
  return { id: tourneyPoints.pid, ...tourneyPoints };
}
interface TourneyParams {
  tourneyId: string;
}

const TourneyPoints = () => {
  const game = useGame();
  const { authorizedServices } = useAuth();
  const { tourneyId } = useParams<TourneyParams>();

  async function runSearch(requestTourneyId: string, cancelToken: CancelToken | undefined) {
    const response = await authorizedServices
      .get<EndPoint>(`/admin/tourney/points/${requestTourneyId}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: {} } as AxiosResponse<EndPoint>;
        throw error;
      });

    return response.data;
  }

  const formData = useFormData(tourneyId, runSearch, { autoRequest: true });
  const { response: result, loading, error } = formData;

  if (loading) return <Loading loading />;
  if (error) return <ErrorDisplay error={error} />;
  if (!result) return null;

  const { tourney, tourneyPoints } = result;

  const rows = tourneyPoints.map(createData) || [];

  return (
    <ContentArea>
      <TourneyTable>
        {game.type === GameType.Praia && <TourneyInfosPraia tourneyInfo={tourney} />}
        {game.type === GameType.Rex && <TourneyInfosRex tourneyInfo={tourney} />}
        <MainDataGrid rows={rows} columns={columns} loading={loading} error={error} defaultPagination />
      </TourneyTable>
    </ContentArea>
  );
};

export default TourneyPoints;
